// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import ReactMarkdown, { ReactMarkdownProps } from "react-markdown";

import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import Paragraph from "components/ui/Paragraph";
import React from "react";
import TestRunStepLink from "components/TestRun/TestRunStepLink";
import Typography from "@material-ui/core/Typography";

const renderers: any = {
  link: (props: any) => {
    const { href } = props;
    const extraProps: any = {};
    if (href.startsWith("~")) {
      return <TestRunStepLink nav={href.split("~")[1]} {...props} />;
    } else if (href.startsWith("http")) {
      const a = document.createElement("a");
      a.href = href;
      if (a.origin !== document.location.origin) {
        extraProps.target = "_blank";
        extraProps.rel = "noopener noreferrer";
        return (
          <a {...props} {...extraProps}>
            {props.children}
            <OpenInNewIcon fontSize="inherit" />
          </a>
        );
      }
    }
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    return <a {...props} {...extraProps} />;
  },

  paragraph: (props: any) => {
    return <Paragraph {...props} />;
  },
};

interface MarkDownProps extends ReactMarkdownProps {
  // Overrides the default paragraph component.
  // This is useful when some component don't support children with
  // specific display type.
  // ie: a <p /> should node have block type children (as a p inside a p).
  paragraphComponent?: "span" | "div";
}

const MarkDown: React.FunctionComponent<MarkDownProps> = props => {
  const { paragraphComponent, ...rest } = props;
  // eslint-disable-next-line prefer-const
  let { source, ...otherProps } = rest;
  let _renderers = renderers;
  if (paragraphComponent) {
    _renderers = {
      ..._renderers,
      paragraph: (props: any) => {
        return (
          <Typography
            variant="body2"
            component={paragraphComponent}
            {...props}
          />
        );
      },
    };
  }

  if (source !== undefined) {
    // This is for FBT objects that needs to be converted to string.
    // Ideally this should be fixed within the FBT api to return the correct
    // type at all times, but it's not.
    source = source.toString();
  }
  return (
    <ReactMarkdown renderers={_renderers} source={source} {...otherProps} />
  );
};

export default MarkDown;
